import { call, put, takeLatest } from 'redux-saga/effects';
import HeroPillsAPI from 'api-services/HeroPillsApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { SET_EVERYDAY_PILLS_DATA, MOVE_PILL, REMOVE_PILL, SET_PILL_REFILL_STATE } from './actionTypes';
import { doneFetchingPillsData, errorFetchingPillsData, doneAddingPill, doneAddingPillFRE, errorAddingPill, doneRemovingPill, errorRemovingPill, doneFetchingDayToDayPillsData, getDayToDayPillsData } from './actionCreators';
import { fetchSchedules } from '../schedules/actionCreators';
import { startSessionHelper, checkUserHelper, checkSessionHelper } from '../utils/helperSagas';
import { doneClosingSession } from '../sessions/actionCreators';
import { logout } from '../auth/actionCreators';
export function* getPills(constAccessParams, action) {
    const { session, getSchedules } = action.data;
    // Check current user access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    // Result is null until proven otherwise
    let result = null;
    // Fetch session in progress if exists
    const currentSession = yield call(checkSessionHelper, newAccessParams);
    // Fetch current device config
    if (!session || !currentSession) {
        result = yield call(HeroPillsAPI.getPillsData, newAccessParams);
    }
    else if (currentSession) {
        const session = yield call(startSessionHelper, newAccessParams);
        if (session) {
            const date = new Date();
            result = yield call(HeroPillsAPI.getPillsUnconfirmedData, newAccessParams, currentSession, session, parseInt(String(date.getTimezoneOffset() / 60), 10));
        }
    }
    else {
        // TODO: CHECK IF THIS CASE IS EVEN POSSIBLE!
        // Otherwise just return empty array and cleanup session since no current one found
        yield put(doneClosingSession({}));
        result = {
            statusCode: 0,
            data: {
                pills: [],
                parental_lock: null,
                timezone_offset: null,
                travel_mode: false,
                update_error: null,
                update_error_msg: null
            }
        };
    }
    if (result && isSuccessResponse(result)) {
        if (getSchedules) {
            yield put(fetchSchedules());
        }
        yield put(doneFetchingPillsData(result.data));
    }
    else {
        yield put(errorFetchingPillsData(result === null || result === void 0 ? void 0 : result.msg));
    }
}
export function* getDayToDayPills(constAccessParams, action) {
    const { getSchedules } = action.data;
    // Check current user token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    // Get pills
    const result = yield call(HeroPillsAPI.getDayToDayPills, newAccessParams);
    // Broadcast result
    if (isSuccessResponse(result)) {
        if (getSchedules) {
            yield put(fetchSchedules());
        }
        yield put(doneFetchingDayToDayPillsData(result.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(errorFetchingPillsData(result.msg));
    }
}
export function* getPillsDataCaregiver(constAccessParams, action) {
    const { getSchedules } = action.data;
    // Check current user token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    // Get pills
    const result = yield call(HeroPillsAPI.getPillsData, newAccessParams);
    // Broadcast result
    if (isSuccessResponse(result)) {
        if (getSchedules) {
            yield put(fetchSchedules());
        }
        yield put(doneFetchingPillsData(result.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(errorFetchingPillsData(result.msg));
    }
}
export function* setDayToDay(constAccessParams, action) {
    const { config, trackType } = action.data;
    delete action.data.piggyback;
    // Check current user token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    // Add pill
    const result = yield call(HeroPillsAPI.setDayToDayPills, newAccessParams, config);
    // Broadcast result
    if (isSuccessResponse(result)) {
        yield put(fetchSchedules());
        yield put(doneAddingPill(Object.assign(Object.assign({}, result.data), { trackType: trackType })));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(errorAddingPill(result.msg));
    }
}
export function* watchSetDayToDayPills(constAccessParams) {
    yield takeLatest(SET_EVERYDAY_PILLS_DATA, setDayToDay, constAccessParams);
}
export function* addPill(constAccessParams, action) {
    const { pill, trackType } = action.data;
    // Check current user token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    // Check session
    const currentSession = yield call(checkSessionHelper, newAccessParams);
    // Start new one if needed
    const session = !currentSession
        ? yield call(startSessionHelper, newAccessParams)
        : currentSession;
    let result = null;
    if (session) {
        // Add pill
        result = yield call(HeroPillsAPI.addPillData, newAccessParams, session, pill);
    }
    // Broadcast result
    if (result && isSuccessResponse(result)) {
        yield put(doneAddingPillFRE(Object.assign(Object.assign({}, result.data), { trackType: trackType })));
    }
    else if ((result === null || result === void 0 ? void 0 : result.statusCode) === 4) {
        yield put(logout());
    }
    else {
        yield put(errorAddingPill(result === null || result === void 0 ? void 0 : result.msg));
    }
}
export function* watchAddPillsCalls(constAccessParams) {
    yield takeLatest('ADD_PILL', addPill, constAccessParams);
}
export function* movePillsCalls(constAccessParams, action) {
    const { slot, pill, trackType } = action.data;
    // Check current user token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    // Check session
    const currentSession = yield call(checkSessionHelper, newAccessParams);
    // Start new one if needed
    const session = !currentSession
        ? yield call(startSessionHelper, newAccessParams)
        : currentSession;
    let result = null;
    if (session) {
        // Move pill
        result = yield call(HeroPillsAPI.movePillData, newAccessParams, session, slot, pill);
    }
    // Broadcast result
    if (result && isSuccessResponse(result)) {
        yield put(doneAddingPill(Object.assign(Object.assign({}, result.data), { trackType: trackType })));
    }
    else if ((result === null || result === void 0 ? void 0 : result.statusCode) === 4) {
        yield put(logout());
    }
    else {
        yield put(errorAddingPill(result === null || result === void 0 ? void 0 : result.msg));
    }
}
export function* watchMovePillsCalls(constAccessParams) {
    yield takeLatest(MOVE_PILL, movePillsCalls, constAccessParams);
}
export function* removePill(constAccessParams, action) {
    const { slot, trackType } = action.data;
    // Check current user token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    // Check session
    const currentSession = yield call(checkSessionHelper, newAccessParams);
    // Start new one if needed
    const session = !currentSession
        ? yield call(startSessionHelper, newAccessParams)
        : currentSession;
    let result = null;
    if (session) {
        // Remove pill
        result = yield call(HeroPillsAPI.removePillData, newAccessParams, session, slot);
    }
    // Broadcast result
    if (result && isSuccessResponse(result)) {
        yield put(doneRemovingPill(Object.assign(Object.assign({}, result.data), { trackType: trackType })));
    }
    else if ((result === null || result === void 0 ? void 0 : result.statusCode) === 4) {
        yield put(logout());
    }
    else {
        yield put(errorRemovingPill(result === null || result === void 0 ? void 0 : result.msg));
    }
}
export function* watchRemovePillsCalls(constAccessParams) {
    yield takeLatest(REMOVE_PILL, removePill, constAccessParams);
}
export function* setRefillState(constAccessParams, action) {
    const { slot, refill_prompt } = action.data;
    // Check current user token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    // Set pill refill state
    const result = yield call(HeroPillsAPI.setRefillState, newAccessParams, slot, refill_prompt);
    // Broadcast result
    if (isSuccessResponse(result)) {
        yield call(getDayToDayPills, constAccessParams, getDayToDayPillsData({ getSchedules: true }));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(errorFetchingPillsData(result.msg));
    }
}
export function* watchSetRefillStateCalls(constAccessParams) {
    yield takeLatest(SET_PILL_REFILL_STATE, setRefillState, constAccessParams);
}
//# sourceMappingURL=saga.js.map